import Rails from "@rails/ujs"

if (!window._rails_loaded) Rails.start()
